import HttpCliente from '../HttpCliente';

/**
 * GET method - Obtiene la lista paginada de Eventos
 * @param {Function} setEventos función para establecer la lista de eventos
 * @param {Function} setError función para establecer el estado de error
 * @param {number} pageNumber número de página
 * @param {number} pageSize tamaño de página
 * @param {string} searchTerm término de búsqueda opcional
 * @param {string} token token de autenticación
 * @return {Promise} Promesa de obtención
 */
export const getEventosPaginados = (setEventos, setError, pageNumber = 1, pageSize = 10, searchTerm = "", token) => {
    return new Promise((resolve, reject) => {
        let url = `/Evento/paged?pageNumber=${pageNumber}&pageSize=${pageSize}`;
        
        if (searchTerm && searchTerm.trim() !== "") {
            url += `&searchTerm=${encodeURIComponent(searchTerm)}`;
        }
        
        HttpCliente.get(url, {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                setEventos(response.data);
                resolve(response.data);
            } else {
                setError(response.data.message);
                reject(response.data.message);
            }
        })
        .catch(error => {
            const errorMessage = error.response?.data?.message || "Error de conexión";
            setError(errorMessage);
            reject(errorMessage);
        });
    });
};

/**
 * GET method - Obtiene información de un Evento por ID
 * @param {string} id ID del evento
 * @param {Function} setEvento función para establecer el evento
 * @param {Function} setError función para establecer el estado de error
 * @param {string} token token de autenticación
 * @return {Promise} Promesa de obtención
 */
export const getEventoById = (id, setEvento, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.get(`/Evento/${id}`, {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                setEvento(response.data.data);
                resolve(response.data);
            } else {
                setError(response.data.message);
                reject(response.data.message);
            }
        })
        .catch(error => {
            const errorMessage = error.response?.data?.message || "Error de conexión";
            setError(errorMessage);
            reject(errorMessage);
        });
    });
};

/**
 * POST method - Crea un nuevo Evento
 * @param {Object} eventoData datos del nuevo evento
 * @param {Function} setError función para establecer el estado de error
 * @param {string} token token de autenticación
 * @return {Promise} Promesa de creación
 */
export const createEvento = (eventoData, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.post("/Evento", eventoData, {
            headers: {
                "Authorization": `Bearer ${token}`,
                'Content-Type': 'application/json',
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 201 || response.status === 200) {
                resolve(response.data);
            } else {
                setError(response.data.message);
                reject(response.data.message);
            }
        })
        .catch(error => {
            const errorMessage = error.response?.data?.message || "Error al crear el evento";
            setError(errorMessage);
            reject(errorMessage);
        });
    });
};

/**
 * GET method - Obtiene todos los lugares disponibles
 * @param {Function} setLugares función para establecer la lista de lugares
 * @param {Function} setError función para establecer el estado de error
 * @param {string} token token de autenticación
 * @return {Promise} Promesa de obtención
 */
export const getLugares = (setLugares, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.get("/LugarEvento", {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                setLugares(response.data.data || []);
                resolve(response.data);
            } else {
                setError(response.data.message);
                reject(response.data.message);
            }
        })
        .catch(error => {
            const errorMessage = error.response?.data?.message || "Error al obtener lugares";
            setError(errorMessage);
            reject(errorMessage);
        });
    });
};

/**
 * PUT method - Actualiza un evento existente
 */
export const updateEvento = (id, eventoData, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.put(`/Evento/${id}`, eventoData, {
            headers: {
                "Authorization": `Bearer ${token}`,
                'Content-Type': 'application/json',
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                resolve(response.data);
            } else {
                setError(response.data.message);
                reject(response.data.message);
            }
        })
        .catch(error => {
            const errorMessage = error.response?.data?.message || "Error al actualizar el evento";
            setError(errorMessage);
            reject(errorMessage);
        });
    });
};

/**
 * PATCH method - Toggle status de un evento
 */
export const toggleEventoStatus = (id, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.patch(`/Evento/${id}/toggle-status`, {}, {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                resolve(response.data);
            } else {
                setError(response.data.message);
                reject(response.data.message);
            }
        })
        .catch(error => {
            const errorMessage = error.response?.data?.message || "Error al cambiar estado del evento";
            setError(errorMessage);
            reject(errorMessage);
        });
    });
};

/**
 * DELETE method - Elimina un evento
 */
export const deleteEvento = (id, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.delete(`/Evento/${id}`, {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                resolve(response.data);
            } else {
                setError(response.data.message);
                reject(response.data.message);
            }
        })
        .catch(error => {
            const errorMessage = error.response?.data?.message || "Error al eliminar el evento";
            setError(errorMessage);
            reject(errorMessage);
        });
    });
};